(() => {
  if (window.__powlifeWhyLoveCopyReady) return;
  window.__powlifeWhyLoveCopyReady = true;

  const copyByProductId = {
    '10489083330877': `You’ll love the extra peace of mind this collar brings when your curious cat is exploring the house, slipping into the yard, or joining you outdoors, with a dedicated tracker holder that keeps their locator close, reflective details and sound finding that make them easier to spot nearby, a breakaway buckle designed for safer everyday wear, and no monthly subscription adding another recurring bill to your routine.`,
    '10474766696765': `You’ll love feeling a little more relaxed when your pet is eager to explore beyond the front door, because the soft harness wraps comfortably around the body while the hook-and-loop closure and safety buckle add two layers of security to help reduce those heart-stopping moments when a pet tries to back out, and reflective details make neighborhood walks, evening strolls, and supervised outdoor time feel a little easier to enjoy together.`,
    '10489083363645': `You’ll love watching mealtime feel calmer instead of seeing your pet rush through every bite, because the raised feeding pattern encourages them to slow down and work around the bowl for their food, turning an everyday meal into a more engaging routine that is especially helpful for enthusiastic eaters who seem finished before you’ve even put the food away.`,
    '10476076007741': `You’ll love how much easier everyday water breaks feel with this bowl around, especially if your pet tends to splash, dip their whole face into the water, or leave little puddles across the floor, because the floating top helps keep drinking calmer and cleaner so there’s less wiping, less wet fur, and one less small mess to think about whether the bowl is beside their food at home or keeping them refreshed through a long afternoon of drinking and playing.`,
    '10478803976509': `You’ll love having one less thing to juggle when you head out with your pet, because water and food stay together in one compact bottle that makes neighborhood walks, park days, and longer drives easier to manage, while the carry strap keeps it simple to bring along so you can offer a quick drink or snack without packing separate containers every time.`,
    '10482223743293': `You’ll love how much less messy grooming can feel when loose fur isn’t floating all over your clothes, couch, and floor, because the fine mist helps calm dry flyaway hair as you brush, the curved steel pins gather loose fur through the coat, and the one-press release makes cleanup quick enough for both regular grooming sessions and those little touch-ups in between.`,
  };

  const recommendationProducts = [
    {
      handle: 'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats',
      title: '2-in-1 Pet Water & Food Bottle',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_22_04_49.png?v=1788072762',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_22_29_06.png?v=1788072762'
    },
    {
      handle: 'calm-feeding-set',
      title: 'Calm Meals & Clean Hydration Set',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_30_00_22_50.png?v=1788075989',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_19_12_03.png?v=1788072986'
    },
    {
      handle: 'care-go-set',
      url: '/products/care-go-set',
      title: 'Care & Go Set',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/759d8749-dab5-4c6b-a3f9-1ae953304c16.png?v=1788072762',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/526c1efa-3645-493d-b859-aa56df1173f6.png?v=1788075341'
    },
    {
      handle: 'elevated-anti-splash-floating-cat-water-bowl',
      title: 'Pet Floating Water Bowl',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_19_12_03.png?v=1788072986',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_28_19_13_20.png?v=1788072987'
    },
    {
      handle: 'soft-no-pull-cat-harness-leash-set-comfortable-adjustable-walking-vest-for-cats-small-dogs',
      title: 'Pet Harness & Leash Set',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_8_23_00_33_28.png?v=1788097488',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_23_01_58_23.png?v=1788075861'
    },
    {
      handle: '3-in-1-pet-mist-grooming-brush-deshed-detangle-refresh',
      title: 'Pet Mist Grooming Brush',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/97027660-8335-4078-b121-156273111397.png?v=1788075341',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/70113777-114b-459f-9ab4-be0452df12d4.png?v=1788075341'
    },
    {
      handle: 'slow-feeder-bowl-for-cats-dogs-slower-calmer-mealtimes',
      title: 'Pet Slow Feeder Bowl',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_30_00_22_50.png?v=1788075989',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_30_00_50_43_b036cf4d-0640-4bed-aa44-4c34fde83144.png?v=1788075989'
    },
    {
      handle: 'smart-pet-tracker-collar-dual-system-tracking-no-monthly-fee',
      title: 'Smart Pet Tracker Collar',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPT_Image_2026_9_3_22_18_28.png?v=1788448470',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/2cf8b1c5-416b-46a2-833c-7ecdf44b8e46.png?v=1788667847'
    },
    {
      handle: 'walk-explore-set',
      title: 'Walk & Explore Set',
      image: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_8_23_15_17_02.png?v=1788076080',
      hoverImage: 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/2a61313d-cbbc-4111-a804-c39cfd266398_35452e68-9c2a-4443-9fc8-69536f142eb3.png?v=1788076080'
    }
  ];

  const getProductId = async () => {
    const path = window.location.pathname.replace(/\.js$/, '').replace(/\/$/, '');
    const response = await fetch(`${path}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Unable to load product data (${response.status})`);
    const product = await response.json();
    return String(product?.id || '');
  };

  const getCurrentHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const applyCopy = (root, text) => {
    const firstAccordion = root?.querySelector('.pl-buy__accordions > details:first-child');
    const body = firstAccordion?.querySelector('.pl-rte');
    if (!body || body.dataset.powlifeWhyLoveUpdated === 'true') return;
    body.innerHTML = `<div class="pl-accordion-custom"><p>${text}</p></div>`;
    body.dataset.powlifeWhyLoveUpdated = 'true';
  };

  const ensureRecommendationStyles = () => {
    if (document.getElementById('powlife-more-products-style')) return;
    const style = document.createElement('style');
    style.id = 'powlife-more-products-style';
    style.textContent = `
      .pll-guide,.pll-details{display:none!important}
      .pll-more{border-top:1px solid #dfe3e5;background:#f7f8fa;padding:68px max(18px,2vw) 84px}
      .pll-more__inner{width:100%;max-width:none;margin:0 auto}
      .pll-more__title{font-family:Georgia,'Times New Roman',serif;font-size:clamp(30px,3vw,44px);font-weight:400;line-height:1.05;letter-spacing:-.035em;margin:0 0 32px;color:#202427}
      .pll-more__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:14px}
      .pll-more__card{display:block;min-width:0;background:#fff;color:#202427;text-decoration:none;border:1px solid #e1e4e5;overflow:hidden;transition:transform .2s ease,border-color .2s ease}
      .pll-more__card:hover{transform:translateY(-2px);border-color:#bfc4c7}
      .pll-more__media{position:relative;aspect-ratio:1/1;background:#eef0f1;overflow:hidden}
      .pll-more__media img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover;transition:opacity .32s ease,transform .38s ease}
      .pll-more__img--primary{opacity:1;z-index:1}
      .pll-more__img--hover{opacity:0;z-index:2}
      @media (hover:hover) and (pointer:fine){
        .pll-more__card:hover .pll-more__img--primary{opacity:0}
        .pll-more__card:hover .pll-more__img--hover{opacity:1;transform:scale(1.015)}
      }
      .pll-more__meta{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:17px 16px 18px}
      .pll-more__meta h3{min-width:0;margin:0;font:inherit;font-size:14px;font-weight:700;line-height:1.35;color:#202427}
      .pll-more__meta span{flex:0 0 auto;font-size:17px;line-height:1;color:#5d6569}
      @media(max-width:989px){
        .pll-more{padding:52px 16px 64px}
        .pll-more__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}
      }
      @media(max-width:749px){
        .pll-more{padding:42px 12px 54px}
        .pll-more__title{font-size:28px;margin-bottom:22px}
        .pll-more__grid{gap:8px}
        .pll-more__meta{padding:12px 10px 13px;align-items:flex-start}
        .pll-more__meta h3{font-size:12px}
        .pll-more__meta span{font-size:15px}
      }
    `;
    document.head.appendChild(style);
  };

  const buildRecommendations = () => {
    const lower = document.querySelector('[data-powlife-lower]');
    if (!lower) return;

    lower.querySelectorAll('.pll-guide,.pll-details').forEach((node) => node.remove());
    lower.querySelectorAll('.pll-more').forEach((node) => node.remove());

    ensureRecommendationStyles();

    const currentHandle = getCurrentHandle();
    const products = recommendationProducts
      .filter((item) => item.handle !== currentHandle && item.handle !== '3m-retractable-pet-leash')
      .slice(0, 8);

    if (!products.length) return;

    const section = document.createElement('section');
    section.className = 'pll-more';
    section.setAttribute('aria-label', 'Explore more products');

    const inner = document.createElement('div');
    inner.className = 'pll-more__inner';

    const title = document.createElement('h2');
    title.className = 'pll-more__title';
    title.textContent = 'Explore More';
    inner.appendChild(title);

    const grid = document.createElement('div');
    grid.className = 'pll-more__grid';

    products.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'pll-more__card';
      card.href = item.url || `/products/${item.handle}`;
      card.setAttribute('aria-label', `View ${item.title}`);

      const media = document.createElement('div');
      media.className = 'pll-more__media';

      const primaryImg = document.createElement('img');
      primaryImg.className = 'pll-more__img--primary';
      primaryImg.src = item.image;
      primaryImg.alt = item.title;
      primaryImg.loading = 'lazy';
      media.appendChild(primaryImg);

      if (item.hoverImage) {
        const hoverImg = document.createElement('img');
        hoverImg.className = 'pll-more__img--hover';
        hoverImg.src = item.hoverImage;
        hoverImg.alt = '';
        hoverImg.loading = 'lazy';
        hoverImg.setAttribute('aria-hidden', 'true');
        media.appendChild(hoverImg);
      }

      const meta = document.createElement('div');
      meta.className = 'pll-more__meta';
      const heading = document.createElement('h3');
      heading.textContent = item.title;
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      meta.appendChild(heading);
      meta.appendChild(arrow);

      card.appendChild(media);
      card.appendChild(meta);
      grid.appendChild(card);
    });

    inner.appendChild(grid);
    section.appendChild(inner);
    lower.appendChild(section);
  };

  const sync = async () => {
    buildRecommendations();

    const roots = [...document.querySelectorAll('[data-powlife-product]')];
    if (!roots.length) return;
    try {
      const productId = await getProductId();
      const text = copyByProductId[productId];
      if (!text) return;
      roots.forEach((root) => applyCopy(root, text));
      const observer = new MutationObserver(() => roots.forEach((root) => {
        const body = root.querySelector('.pl-buy__accordions > details:first-child .pl-rte');
        if (body && !body.dataset.powlifeWhyLoveUpdated) applyCopy(root, text);
        if (body?.querySelector('ul')) {
          body.dataset.powlifeWhyLoveUpdated = '';
          applyCopy(root, text);
        }
      }));
      roots.forEach((root) => observer.observe(root.querySelector('.pl-buy__accordions') || root, { childList: true, subtree: true }));
    } catch (error) {
      console.warn('[POWLIFE] Why-you’ll-love-it copy sync failed:', error);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  document.addEventListener('shopify:section:load', sync);
})();